import React from 'react';
import ReactTooltip from "react-tooltip";
import './styles.css';

const timestamp = window.appVersionTimestamp;
const formatedTimestampDate = new Date(timestamp).toLocaleDateString('pt-BR', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
});

function Version() {
  return (
    <React.Fragment>
      <ReactTooltip
        place="top"
        type="dark"
        effect="float"
        className="tooltip"
      />
      <p
        className="seb-version-container"
        data-tip={`Versão ${window.appVersion} - ${formatedTimestampDate}`}
      >
        v{window.appVersion}
      </p>
    </React.Fragment>
  );
}

export default Version;
